import React from 'react';
import { motion } from 'framer-motion';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Button } from '../components/Button';
import { ArrowRightIcon, SnowflakeIcon } from 'lucide-react';
export function HomePage() {
  return <div className="w-full" data-id="element-131">
      <Hero data-id="element-132" />
      <Features data-id="element-133" />

      {/* CTA Section */}
      <div id="signup" className="bg-gradient-to-b from-m3-primary via-m3-surface to-m3-surface-container py-20 relative overflow-hidden border-t-4 border-m3-on-surface" data-id="element-134">
        {/* Animated Snowflakes */}
        <motion.div className="absolute top-10 left-20 text-m3-outline opacity-60" animate={{
        y: [0, 30, 0],
        x: [-3, 3, -3],
        rotate: [0, 360]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-135">
          <SnowflakeIcon className="w-6 h-6" data-id="element-136" />
        </motion.div>

        <motion.div className="absolute top-32 right-16 text-m3-on-surface opacity-50" animate={{
        y: [0, 25, 0],
        x: [2, -2, 2],
        rotate: [0, -360]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} data-id="element-137">
          <SnowflakeIcon className="w-4 h-4" data-id="element-138" />
        </motion.div>

        <motion.div className="absolute bottom-24 right-32 text-word-error-light opacity-70" animate={{
        y: [0, 20, 0],
        x: [-4, 4, -4],
        rotate: [0, 360]
      }} transition={{
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2
      }} data-id="element-139">
          <SnowflakeIcon className="w-8 h-8" data-id="element-140" />
        </motion.div>

        <motion.div className="absolute top-48 left-1/4 text-m3-on-surface-light opacity-40" animate={{
        y: [0, 35, 0],
        x: [3, -3, 3],
        rotate: [0, -360]
      }} transition={{
        duration: 9,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.5
      }} data-id="element-141">
          <SnowflakeIcon className="w-5 h-5" data-id="element-142" />
        </motion.div>

        <motion.div className="absolute bottom-32 left-16 text-word-current opacity-60" animate={{
        y: [0, 28, 0],
        x: [-2, 2, -2],
        rotate: [0, 360]
      }} transition={{
        duration: 11,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1.5
      }} data-id="element-143">
          <SnowflakeIcon className="w-6 h-6" data-id="element-144" />
        </motion.div>

        <motion.div className="absolute top-20 right-1/3 text-m3-outline opacity-50" animate={{
        y: [0, 22, 0],
        x: [4, -4, 4],
        rotate: [0, -360]
      }} transition={{
        duration: 8.5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2.5
      }} data-id="element-145">
          <SnowflakeIcon className="w-4 h-4" data-id="element-146" />
        </motion.div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative" data-id="element-147">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-148">
            <h2 className="text-5xl sm:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-m3-on-surface via-m3-on-surface-light to-m3-outline mb-6 uppercase" style={{
            textShadow: '0 0 30px rgba(13,112,128,0.2)'
          }} data-id="element-149">
              Ready Player One?
            </h2>
            <p className="text-base text-m3-on-surface-variant mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-150">
              Join thousands of families, teachers, and tutors who are making
              reading practice more engaging and effective with Snow Day.
            </p>
          </motion.div>

          <motion.div className="flex flex-col sm:flex-row gap-6 justify-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-151">
            <Button variant="primary" size="lg" href="https://app.snowdayacademy.com" data-id="element-152">
              Start Game
              <ArrowRightIcon className="w-5 h-5" data-id="element-153" />
            </Button>
            <Button variant="outline" size="lg" href="/contact" data-id="element-154">
              Contact Us
            </Button>
          </motion.div>

          <motion.div className="mt-12 inline-block bg-white/80 border-4 border-m3-outline px-8 py-4 pixel-corners" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-155">
            <p className="text-xs text-m3-outline uppercase tracking-widest font-bold" data-id="element-156">
              ★★★ Achievement Unlocked: Join Now ★★★
            </p>
          </motion.div>
        </div>
      </div>
    </div>;
}